<template>
    <div>
        <div class="c-alert__table editable_table flex flex-col w-full border-none">
            <v-data-table
                single-select
                :headers="headers"
                :items="practiceList"
                :items-per-page="5"
                :item-class="() => 'cursor-pointer'"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :footer-props="footerProps"
                :no-data-text="emptyText"
                :no-results-text="emptyText"
                class="a-table w-full"
                @click:row="rowClickHandler"
            >
            <template v-slot:[`item.redirect`]="{ item }">
                <div
                    class="text-right tablet-hide"
                    :class="{'active-tr': item.active}"
                >
                    <a
                        href="#"
                        @click.prevent="rowClickHandler(item)"
                        class="hover:text-primary-light mx-2"
                    >
                        <fa-icon icon="chevron-right" class="text-grey-2 ml-3" />
                    </a>
                </div>
            </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
import WarningIcon from '@/assets/icons/icons_warning.svg'

export default {
    name: 'PracticeNonConformities',
    components: { WarningIcon },
    data() {
        return {    
            emptyText: 'Not found',
            headers: [
                { text: 'Practice', align: 'left', value: 'practiceName', class: 'w-150 count--header' },
                { text: 'Total Non-Conformities', align: 'left', value: 'numNotMets', class: 'w-250 count--header' },
                { text: 'Critical Rating', align: 'left', value: 'critical', class: 'w-150 count--header' },
                { text: 'High Rating', align: 'left', value: 'high', class: 'w-250 count--header' },
                { text: 'Medium Rating', align: 'left', value: 'moderate', class: 'w-250 count--header' },
                { text: 'Low Rating', align: 'left', value: 'low', class: 'w-250 count--header'  },
                { text: '', align: 'left', value: 'redirect', fixed: true, sortable: false},
            ],
            footerProps: {
                'items-per-page-text':'',
                'items-per-page-options': [5, 10, 20, 30, 40],
                showFirstLastPage: true
            },
            sortBy: 'numNotMets',
            sortDesc: true,
        }
    },
    props: {
      practiceList: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        rowClickHandler(obj, e) {
            const url = this.$router
                .resolve({
                    name: 'Staff',
                    params: {id: obj.practiceId}
                })
            window.open(url.href, '_blank')
        },     
    }
}
</script>